<template>
  <div id="app">
    <!-- 顶部导航 -->
    <div class="header" :class="{ header_scrolled: headerScrolled }">
      <div class="center">
        <a-row type="flex" justify="space-between" align="middle">
          <a-col span="12">
            <img class="header_logo" src="../assets/logo_blue.png" alt="">
            <span class="header_logo_text">典通档案</span>
          </a-col>
          <a-col span="12" style="text-align: right;">
            <a-button type="primary" shape="round" icon="phone" size="large" class="btn_gradient" @click.native.stop="callHotline">
              13390116589
            </a-button>
          </a-col>
        </a-row>
      </div>
    </div>

    <!-- 焦点图 -->
     <div class="banner_top">
      <div class="center">
        <a-row class="center" type="flex" justify="space-between">
          <a-col :xl="11" :xs="24">
            <img style="width: 100%;" src="../assets/index_img/banner_leftimg.png" alt="">
          </a-col>
          <a-col :xl="13" :xs="24" style="text-align: center;">
            <img style="width: 100%;" src="../assets/index_img/banner_rightimg.png" alt="">
            <a-button type="primary" ghost shape="round" icon="play-circle" size="large" class="radio_link">观看演示</a-button>
          </a-col>
        </a-row>
      </div>
      <div class="banner_list_mian">
        <a-row type="flex" class="center">
            <a-col :xl="6" :xs="12" class="banner_list">
              <div class="text_blue fs_40">10,000+</div>
              <div class="fs_20">服务企业</div>
            </a-col>
            <a-col :xl="6" :xs="12" class="banner_list">
              <div class="text_blue fs_40">99.9%</div>
              <div class="fs_20">系统稳定性</div>
            </a-col>
            <a-col :xl="6" :xs="12" class="banner_list" style="border-right: none;">
              <div class="text_blue fs_40">50+</div>
              <div class="fs_20">行业覆盖</div>
            </a-col>
            <a-col :xl="6" :xs="12" class="banner_list banner_listbg" style="border-right: none;">
              <div class="fs_40">99.9%</div>
              <div class="fs_20">系统稳定性</div>
            </a-col>
          </a-row>
      </div>
     </div>

     <!-- 当档案遇见AI，管理正在被重新定义 -->
     <div class="section section1">
      <div class="section_title">
        <div class="fs_40">当档案遇见AI，管理正在被重新定义</div>
        <div class="fs_20">从“存”到“用”，让档案价值倍增</div>
      </div>
      <div class="center">
        <a-row class="section1_list" type="flex" justify="space-between">
          <a-col :xl="7" :xs="24"><img src="../assets/index_img/section1list1.png" alt=""></a-col>
          <a-col :xl="7" :xs="24"><img src="../assets/index_img/section1list2.png" alt=""></a-col>
          <a-col :xl="7" :xs="24"><img src="../assets/index_img/section1list3.png" alt=""></a-col>
        </a-row>
      </div>
     </div>

     <!-- 业务场景分析 -->
     <div class="section">
        <div class="section_title">
          <div class="section_title_shadow">BUSINESS SCENARIO ANALYSIS</div>
          <div class="fs_40">业务场景分析</div>
          <div class="fs_20">覆盖业务的六大阶段，兼顾电子档案与实体档案</div>
        </div>
        <div class="center">
          <img src="../assets/index_img/section2-1img.png" alt="">
          <img style="margin-top: 20px;" src="../assets/index_img/section2-2img.png" alt="">
        </div>
     </div>

     <!-- 特色功能 -->
     <div class="section section3">
        <div class="section_title">
          <div class="section_title_shadow">KEY FEATURES</div>
          <div class="fs_40">特色功能</div>
          <div class="fs_20">采用先进的AI技术，提供全方位的档案管理解决方案</div>
        </div>
        <div class="center">
          <a-row type="flex" justify="space-between">
            <a-col
              v-for="(item, idx) in section3List"
              :key="item.key"
              class="section3_list"
              :xl="section3ItemExpanded(idx) ? 6 : 3"
              :xs="12"
              @mouseenter="onSection3ListEnter(idx)"
              @mouseleave="onSection3ListLeave"
              :class="{ 'section3_list_hover': section3ItemExpanded(idx) }"
            >
              <a-row>
                <a-col style="text-align: center;" :xl="section3ItemExpanded(idx) ? 11 : 24">
                  <img :src="item.icon" alt="">
                </a-col>
                <a-col :xl="section3ItemExpanded(idx) ? 13 : 24">
                  <div class="section3_list_title">{{ item.title }}</div>
                  <div v-if="section3ItemExpanded(idx)" class="section3_list_desc">{{ item.desc }}</div>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
        </div>
     </div>
     <!-- 全栈产品体系 -->
     <div class="section section4">
        <div class="section_title">
          <div class="section_title_shadow">FULL-STACK PRUDUCT SYSTEM</div>
          <div class="fs_40">全栈产品体系</div>
          <div class="fs_20">覆盖档案全生命周期的十大子系统，满足各类机构需求</div>
        </div>
        <div class="center" style="padding: 0 20px;">
          <a-row type="flex" gutter="20" justify="space-between">
            <a-col :xl="2" :xs="0"></a-col>
            <a-col :xl="4" :xs="12">
              <div class="section4_list section4_list1">
                <img src="../assets/index_img/section4list1.png" alt="">
                <div class="fs_20">电子文件中心</div>
                <div>文件预归档四性检测</div>
              </div>
            </a-col>
            <a-col :xl="4" :xs="12">
              <div class="section4_list section4_list2">
                <img src="../assets/index_img/section4list2.png" alt="">
                <div class="fs_20">虚拟档案室</div>
                <div>在线档案室管理查阅</div>
              </div>
            </a-col>
            <a-col :xl="4" :xs="12">
              <div class="section4_list section4_list3">
                <img src="../assets/index_img/section4list3.png" alt="">
                <div class="fs_20">档案资源接收系统</div>
                <div>多源异构数据自动采集</div>
              </div>
            </a-col>
            <a-col :xl="4" :xs="12">
              <div class="section4_list section4_list4">
                <img src="../assets/index_img/section4list4.png" alt="">
                <div class="fs_20">档案资源管理系统</div>
                <div>全生命周期精细化管理</div>
              </div>
            </a-col>
            <a-col :xl="4" :xs="12">
              <div class="section4_list section4_list5">
                <img src="../assets/index_img/section4list5.png" alt="">
                <div class="fs_20">档案资源利用系统</div>
                <div>在线借阅与共享服务</div>
              </div>
            </a-col>
            <a-col :xl="2" :xs="0"></a-col>
            <a-col :xl="2" :xs="0"></a-col>
            <a-col :xl="4" :xs="12">
              <div class="section4_list section4_list6">
                <img src="../assets/index_img/section4list6.png" alt="">
                <div class="fs_20">电子阅览室</div>
                <div>在线阅读与知识发现</div>
              </div>
            </a-col>
            <a-col :xl="4" :xs="12">
              <div class="section4_list section4_list7">
                <img src="../assets/index_img/section4list7.png" alt="">
                <div class="fs_20">长期保存系统</div>
                <div>符合长期保存标准</div>
              </div>
            </a-col>
            <a-col :xl="4" :xs="12">
              <div class="section4_list section4_list8">
                <img src="../assets/index_img/section4list8.png" alt="">
                <div class="fs_20">资源检索平台</div>
                <div>跨库全文检索与发现</div>
              </div>
            </a-col>
            <a-col :xl="4" :xs="12">
              <div class="section4_list section4_list9">
                <img src="../assets/index_img/section4list9.png" alt="">
                <div class="fs_20">3D库房管理</div>
                <div>可视化实体库房管理</div>
              </div>
            </a-col>
            <a-col :xl="4" :xs="12">
              <div class="section4_list section4_list10">
                <img src="../assets/index_img/section4list10.png" alt="">
                <div class="fs_20">智能 AI助手</div>
                <div>大模型驱动智能引擎</div>
              </div>
            </a-col>
            <a-col :xl="2" :xs="0"></a-col>
          </a-row>
        </div>
     </div>

     <!-- 客户案例 -->
    <div class="section section5">
      <div class="section_title">
        <div class="section_title_shadow">CUSTOMER CASE</div>
        <div class="fs_40">客户案例</div>
        <div class="fs_20">深受政府机关及企事业单位信赖</div>
      </div>
      <div class="center">
        <a-row type="flex" align="middle">
          <a-col :xl="6" :xs="24">
            <a-row type="flex" align="middle">
              <a-col :xl="24" :xs="8"
                v-for="(c, i) in customerCases"
                :key="c.key"
                class="section5_list_title"
                :class="{ 'section5_list_title_active': customerCaseIndex === i }"
                @click.native="onCaseNavClick(i)"
              >
                <a-row type="flex" align="middle">
                  <a-col :xl="8" :xs="0" >
                    <div class="section5_list_title_line"></div>
                  </a-col>
                  <a-col :xl="16" class="section5_list_title_text">{{ c.navLabel }}</a-col>
                </a-row>
              </a-col>
            </a-row>
          </a-col>
          <a-col
            :xl="18"
            :xs="24"
            style="background-position: center right; background-size: cover;"
            :style="{ backgroundImage: 'url(' + currentCustomerCase.bg + ')' }"
          >
            <div class="section5_list_item">
              <div class="fs_30 fw_500">{{ currentCustomerCase.title }}</div>
              <div class="fs_20">{{ currentCustomerCase.subtitle }}</div>
              <div class="section5_list_item_main">{{ currentCustomerCase.quote }}</div>
              <div>
                <span
                  v-for="(tag, ti) in currentCustomerCase.tags"
                  :key="ti"
                  class="section5_list_item_tag"
                >{{ tag }}</span>
              </div>
            </div>
          </a-col>
        </a-row>
      </div>
    </div>

    <!-- 安全合规认证 -->
    <div class="section section6">
      <div class="section_title">
        <div class="section_title_shadow" style="color: #407EF7;">SECURITY COMPLIANCE CERTIFICATION</div>
        <div class="fs_40">安全合规认证</div>
        <div class="fs_20">符合国家档案局标准，通过多项权威认证</div>
      </div>
      <div class="center">
        <a-row type="flex" justify="space-between">
          <a-col :xl="5" :xs="11" style="margin-bottom: 10px;">
            <div class="section6_list">
              <img src="../assets/index_img/section6list1.png" alt="">
              <div class="fs_24">等保三级</div>
              <div class="fs_16">信息系统安全等级保护</div>
            </div>
          </a-col>
          <a-col :xl="5" :xs="11" style="margin-bottom: 10px;">
            <div class="section6_list">
              <img src="../assets/index_img/section6list2.png" alt="">
              <div class="fs_24">GB/T 18894</div>
              <div class="fs_16">电子文件归档管理规范</div>
            </div>
          </a-col>
          <a-col :xl="5" :xs="11" style="margin-bottom: 10px;">
            <div class="section6_list">
              <img src="../assets/index_img/section6list3.png" alt="">
              <div class="fs_24">ISO 27001</div>
              <div class="fs_16">信息安全管理体系认证</div>
            </div>
          </a-col>
          <a-col :xl="5" :xs="11" style="margin-bottom: 10px;">
            <div class="section6_list">
              <img src="../assets/index_img/section6list4.png" alt="">
              <div class="fs_24">国家档案局</div>
              <div class="fs_16">软件测评合格证书</div>
            </div>
          </a-col>
        </a-row>
      </div>
    </div>
    <!-- 版本介绍 -->
    <div class="section section7">
      <div class="section_title">
        <div class="section_title_shadow">VERSION INTRODUCTION</div>
        <div class="fs_40">版本介绍</div>
        <div class="fs_20">选择适合您的部署版本，满足不同规模机构的档案需求</div>
      </div>
      <div class="center">
        <a-row type="flex" justify="space-between">
          <a-col
            style="margin-bottom: 10px;"
            v-for="(v, idx) in section7Versions"
            :key="v.key"
            :xl="section7ActiveIndex === idx ? 13 : 5"
            :xs="24"
            :class="['section7_list', v.themeClass, { 'section7_list_active': isMobileFeatures || section7ActiveIndex === idx }]"
            @click.native="onSection7Click(idx)"
          >
            <img class="section7_list_bg" :src="v.bgImg" alt="">
            <div class="section7_list1_title">
              <div class="fs_30">{{ v.title }}</div>
              <div class="fs_16">{{ v.subtitle }}</div>
            </div>
            <div class="section7_list_main">
              <div
                v-for="(f, fi) in v.features"
                :key="fi"
                class="section7_list_main_tag"
              >
                <img src="../assets/index_img/section7check.png" alt="">
                <span>{{ f }}</span>
              </div>
              <a-button
                type="primary"
                size="large"
                class="btn_gradient"
                style="width:250px"
                @click.native.stop="callHotline"
              >
                13390116589
              </a-button>
            </div>
          </a-col>
        </a-row>
      </div>
    </div>

    <!-- 客户评价 -->
    <div class="section section8">
      <div class="section_title">
        <div class="section_title_shadow">CUSTOMER REVIEWS</div>
        <div class="fs_40">客户评价</div>
        <div class="fs_20">听听他们怎么说</div>
      </div>
      <div class="center">
        <a-row type="flex" justify="space-between">
          <a-col :xl="7" :xs="24" style="margin-bottom: 20px;">
            <div class="section8_reviews_msg">
              <span></span>
              <a-rate defaultValue="5" />
              <div style="margin-top: 10px;">"系统安全性非常好，使用了两年没有出现过数据丢失的情况。智能分类功能确实节省了大量人力成本。"</div>
            </div>
            <a-row type="flex" align="middle">
              <a-col span="7">
                <img src="../assets/index_img/section8list1.png" alt="">
              </a-col>
              <a-col span="17">
                <div class="fs_30">张主任</div>
                <div class="fs_16">某市档案馆 技术部主任</div>
              </a-col>
            </a-row>
          </a-col>
          <a-col :xl="7" :xs="24">
            <div class="section8_reviews_msg">
              <span></span>
              <a-rate defaultValue="5" />
              <div style="margin-top: 10px;">"AI 大模型的接入让档案查询变得极其简单，自然语言提问就能找到想要的文件，太神奇了！"</div>
            </div>
            <a-row type="flex" align="middle">
              <a-col span="7">
                <img src="../assets/index_img/section8list2.png" alt="">
              </a-col>
              <a-col span="17">
                <div class="fs_30">李经理</div>
                <div class="fs_16">某制造企业 行政经理</div>
              </a-col>
            </a-row>
          </a-col>
          <a-col :xl="7" :xs="24">
            <div class="section8_reviews_msg">
              <span></span>
              <a-rate defaultValue="5" />
              <div style="margin-top: 10px;">"四性检测功能帮我们通过了严格的档案验收，合规性做得非常到位。技术支持响应也很及时。"</div>
            </div>
            <a-row type="flex" align="middle">
              <a-col span="7">
                <img src="../assets/index_img/section8list3.png" alt="">
              </a-col>
              <a-col span="17">
                <div class="fs_30">王馆长</div>
                <div class="fs_16">某高校档案馆 馆长</div>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </div>
    </div>
    <!-- 升级 -->
    <div class="section section9">
      <div class="section_title">
        <div class="fs_60">准备好升级您的档案管理了吗？</div>
        <div class="fs_30">立刻联系我们，体验智能档案管理带来的效率提升。</div>
        <div class="fs_30">免费预约，在线演示。</div>
      </div>
      <div class="center" style="text-align: center;margin-top: 10px;">
        <a-button type="primary" shape="round" icon="phone" size="large" class="btn_gradient" @click.native.stop="callHotline">
          13390116589
        </a-button>
        <div style="color: #1890FF;margin-top: 20px;">
          <a-icon type="safety-certificate" theme="filled"/>
          <span>企业级安全保障 • 专属客户经理 • 7×24 技术支持</span>
        </div>
      </div>
      <div class="footer">
        <div class="center" style="color: #fff;">
          <a-row type="flex" justify="end">
            <a-col span="24">
              <img class="footer_logo" src="../assets/logo_white.png" alt="">
              <span class="footer_logo_text">典通档案</span>
            </a-col>
            <a-col :xl="7" :xs="24" style="margin-top: 30px;">
              面向政府机构及企事业单位的智能档案管理平台，提供全生命周期档案管理解决方案，助力数字化转型。
            </a-col>
            <a-col :xs="24" style="margin-top: 10px;">
              公司地址：辽宁省沈阳市浑南区五三街道营盘西街37号禹洲广场A2#2-20-1
            </a-col>
            <a-col :xs="24" style="margin-top: 10px;">
              <a style="color: #fff;" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=21011202001234" target="_blank">
                <img class="footer_gaba" src="../assets/gaba.png" alt="">
                辽公网安备21011202001234号
              </a>
            </a-col>
            <a-col :xs="24" style="margin-top: 5px;">
              <a style="color: #fff;" href="https://beian.miit.gov.cn/" target="_blank">辽ICP备2025067935号-2</a>
            </a-col>
            
          </a-row>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'Index',
  data() {
    return {
      customerCaseIndex: 0,
      caseRotateTimerId: null,
      customerCases: [
        {
          key: 'provincial-archives',
          navLabel: '某省级档案馆',
          title: '某省级档案馆',
          subtitle: '数字化转型项目',
          quote: '典通档案帮助我们实现了300万卷历史档案的数字化，检索效率提升80%，极大改善了公众查档体验。',
          tags: ['效率提升 80%', '300万卷档案'],
          bg: require('../assets/index_img/section5list1.png'),
        },
        {
          key: 'high-tech',
          navLabel: '某高新技术企业',
          title: '某高新技术企业',
          subtitle: '研发档案管理',
          quote: '通过四性检测和长期保存系统，我们确保了50年核心技术档案的合规性和安全性，顺利通过了高新技术企业复审。',
          tags: ['合规存储', '50年保存期'],
          bg: require('../assets/index_img/section5list2.png'),
        },
        {
          key: 'media-group',
          navLabel: '某传媒集团',
          title: '某传媒集团',
          subtitle: '新闻素材档案',
          quote: '智能分类和AI检索让记者能快速定位历史采访素材，AI辅助创作功能大幅提升了新闻生产效率。',
          tags: ['检索效率提升', 'AI辅助创作'],
          bg: require('../assets/index_img/section5list3.png'),
        },
      ],
      section7ActiveIndex: 1,
      section7TimerId: null,
      section7Versions: [
        {
          key: 'single',
          themeClass: 'section7_list1',
          title: '单机版',
          subtitle: '满足小型档案室基础管理',
          bgImg: require('../assets/index_img/section7list1.png'),
          features: ['档案收集与整理', '档案保管与统计', '档案利用与检索', '基础权限管理'],
        },
        {
          key: 'network',
          themeClass: 'section7_list2',
          title: '专业版',
          subtitle: '覆盖全流程的档案管理',
          bgImg: require('../assets/index_img/section7list2.png'),
          features: ['包含单机版所有功能', '档案移交与接收管理', '长期保存与四性检测', '精细化权限隔离','智能分类与语义检索'],
        },
        {
          key: 'group',
          themeClass: 'section7_list3',
          title: '定制版',
          subtitle: '根据需求灵活定制',
          bgImg: require('../assets/index_img/section7list3.png'),
          features: ['功能按需定制开发', '私有化/混合云部署', '与现有系统深度集成', '专属客户经理'],
        },
      ],
      /** 滚动超过阈值时 header 白底 */
      headerScrolled: false,
      /** 移动端：每个盒子固定展开样式，不响应鼠标经过 */
      isMobileFeatures: false,
      hoverSection3ListIndex: 0,
      section3List: [
        {
          key: 'smart-classify',
          title: '智能分类',
          desc: '基于主流AI大模型，自动识别档案内容并智能分类，准确率高达 99.2%，大幅减少人工整理时间。',
          icon: require('../assets/index_img/section3list1.png'),
        },
        { key: 'format-convert', title: '格式转换', desc: '支持 OFD、PDF、双层 PDF 等 50+ 格式互转，符合国家电子档案标准，确保长期可读性。', icon: require('../assets/index_img/section3list2.png') },
        { key: 'fulltext-search', title: '全文检索', desc: '毫秒级全文检索，支持 OCR 内容识别搜索，即使扫描件也能快速定位，让查找像百度一样简单。', icon: require('../assets/index_img/section3list3.png') },
        { key: 'integrity-check', title: '四性检测', desc: '自动检测档案真实性、完整性、可用性、安全性，确保电子档案长期保存价值，符合国标要求。', icon: require('../assets/index_img/section3list4.png') },
        { key: 'compliance-store', title: '合规存储', desc: '符合《电子文件管理暂行办法》等法规要求，支持异地备份、离线存储，保障数据绝对安全。', icon: require('../assets/index_img/section3list5.png') },
        { key: 'smart-qa', title: '智慧问答', desc: '基于档案内容的智能问答系统，自然语言查询档案信息，AI 助手 7×24 小时在线服务。', icon: require('../assets/index_img/section3list6.png') },
      ],
    };
  },
  computed: {
    currentCustomerCase() {
      const list = this.customerCases;
      const i = this.customerCaseIndex;
      return list[i] || list[0];
    },
  },
  mounted() {
    this.updateHeaderScrolled();
    window.addEventListener('scroll', this.updateHeaderScrolled, { passive: true });
    this.updateMobileFeatures();
    window.addEventListener('resize', this.updateMobileFeatures);
    this.hoverSection3ListIndex = 0;
    this.startCaseRotate();
    this.startSection7Rotate();
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.updateHeaderScrolled);
    window.removeEventListener('resize', this.updateMobileFeatures);
    this.stopCaseRotate();
    this.stopSection7Rotate();
  },
  methods: {
    startCaseRotate() {
      this.stopCaseRotate();
      this.caseRotateTimerId = setInterval(() => {
        const n = this.customerCases.length;
        this.customerCaseIndex = (this.customerCaseIndex + 1) % n;
      }, 2000);
    },
    stopCaseRotate() {
      if (this.caseRotateTimerId) {
        clearInterval(this.caseRotateTimerId);
        this.caseRotateTimerId = null;
      }
    },
    onCaseNavClick(i) {
      this.customerCaseIndex = i;
      this.startCaseRotate();
    },
    startSection7Rotate() {
      this.stopSection7Rotate();
      this.section7TimerId = setInterval(() => {
        const n = this.section7Versions.length;
        this.section7ActiveIndex = (this.section7ActiveIndex + 1) % n;
      }, 4000);
    },
    stopSection7Rotate() {
      if (this.section7TimerId) {
        clearInterval(this.section7TimerId);
        this.section7TimerId = null;
      }
    },
    onSection7Click(idx) {
      this.section7ActiveIndex = idx;
      this.startSection7Rotate();
    },
    callHotline() {
      window.location.href = 'tel:13390116589';
    }, 
    updateHeaderScrolled() {
      this.headerScrolled = window.scrollY > 80;
    },
    updateMobileFeatures() {
      this.isMobileFeatures = window.innerWidth <= 768;
    },
    section3ItemExpanded(idx) {
      return this.isMobileFeatures || this.hoverSection3ListIndex === idx;
    },
    onSection3ListEnter(idx) {
      if (this.isMobileFeatures) return;
      this.hoverSection3ListIndex = idx;
    },
    onSection3ListLeave() {
      if (this.isMobileFeatures) return;
      this.hoverSection3ListIndex = 0;
    },
  },
};
var _hmt = _hmt || [];
(function() {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?a440e2009f6d93f47bc82183b5138feb";
  var s = document.getElementsByTagName("script")[0]; 
  s.parentNode.insertBefore(hm, s);
})();
</script>


<style scoped>
.banner_top{
  background-image: url(../assets/index_img/banner_bgimg.png);
  background-position: center top;
  background-size: cover;
  padding: 170px 0 0 ;
  margin-top: -80px;
}
.radio_link{
  margin-top: 40px;
}
.banner_list_mian{
  background-image: linear-gradient( to right, #fff 50%, #3860f4 50%);
}
.banner_list{
  text-align: center;
  padding: 30px;
  border-right: solid 1px #D7D7D7;
  background-color: #fff;
}
.banner_listbg{
  background-color: #3861F4;
  background-image: url(../assets/index_img/banner_listbg.png);
  background-repeat: no-repeat;
  color: #fff;
}
.section1{
  background-color: #E5EEFF;
}
.section1 img{
  margin-bottom: 10px;
}
.section1 img:hover{
  transform: scale(1.1);
  transition-duration: 0.5s;
}
.section3{
  background-color: #F2F6FC;
}
.section3_list{
  padding: 20px;
  border-radius: 30px;
}
.section3_list img{
  width: 120px;
}
.section3_list_hover{
  background-image: linear-gradient( to bottom ,#FFFFFF ,rgba(255, 255, 255, 0) );
  padding-left: 0;
}
.section3_list_hover img{
  width: 100%;
}
.section3_list_title{
  font-size: 24px;
  font-weight: 500;
  text-align: center;
  margin-top: 10px;
}
.section3_list_hover .section3_list_title{
  margin-top: 20px;
}
.section3_list_desc{
  font-size: 16px;
  margin-top: 10px;
  text-align: justify;
}


.section4{
  background-image: url(../assets/index_img/section3bg.png);
}
.section4_list{
  padding-bottom: 20px;
  margin-bottom: 20px;
  text-align: center;
  border-radius: 10px;
  border: 1px solid #fff;
}
.section4_list img{
  width: 100%;
}
.section4_list .fs_20{
  font-weight: 500;
}
.section4_list.section4_list1{
  background-image: linear-gradient(135deg, rgba(255, 255, 255, 1) 0%, rgba(217, 223, 255, 1) 100%);
}
.section4_list.section4_list2{
  background-image: linear-gradient(135deg, rgba(255, 255, 255, 1) 0%, rgba(242, 225, 213, 1) 100%);
}
.section4_list.section4_list3{
  background-image: linear-gradient(135deg, rgba(255, 255, 255, 1) 0%, rgba(206, 238, 219, 1) 100%);
}
.section4_list.section4_list4{
  background-image: linear-gradient(135deg, rgba(255, 255, 255, 1) 0%, rgba(255, 238, 242, 1) 100%);
}
.section4_list.section4_list5{
  background-image: linear-gradient(135deg, rgba(255, 255, 255, 1) 0%, rgba(230, 238, 244, 1) 100%);
}
.section4_list.section4_list6{
  background-image: linear-gradient(135deg, rgba(255, 255, 255, 1) 0%, rgba(242, 222, 247, 1) 100%);
}
.section4_list.section4_list7{
  background-image: linear-gradient(135deg, rgba(255, 255, 255, 1) 0%, rgba(227, 227, 227, 1) 100%);
}
.section4_list.section4_list8{
  background-image: linear-gradient(135deg, rgba(255, 255, 255, 1) 0%, rgba(249, 215, 225, 1) 100%);
}
.section4_list.section4_list9{
  background-image: linear-gradient(135deg, rgba(255, 255, 255, 1) 0%, rgba(244, 232, 173, 1) 100%);
}
.section4_list.section4_list10{
  background-image: linear-gradient(135deg, rgba(255, 255, 255, 1) 0%, rgba(246, 207, 201, 1) 100%);
}

.section5{
  background-color: #F2F6FC;
  background-image: url(../assets/index_img/section5bg.png);
  background-position: center bottom;
  background-size: contain;
  background-repeat: no-repeat;
  padding-bottom: 170px;
}
.section5_list_title{
  padding: 25px 0;
  font-size: 24px;
  transition: color 0.2s ease;
}
.section5_list_title_line{
  width: 50px;
  height: 5px;
  border-radius: 3px;
  background: #333;
  margin: 0 auto;
  transition: width 0.2s ease, background-color 0.2s ease;
}
.section5_list_title_active{
  color: #1890FF;
}
.section5_list_title_active .section5_list_title_line{
  width: 90%;
  background: #1890FF;
}
.section5_list_item{
  background-image: linear-gradient( to right, rgba(0,93,199,1) 30%,  rgba(0,93,199,0) 100%);
  padding: 50px;
  color: #fff;
}
.section5_list_item_main{
  padding: 30px;
  max-width: 300px;
  min-height: 160px;
  margin: 20px 0 15px;
  text-align: justify;
  border-radius: 20px;
  border: #fff solid 1px;
  position: relative;
}
.section5_list_item_main::before,.section5_list_item_main::after{
  content: '';
  position: absolute;
  width: 30px;
  height: 26px;
  background-image: url(../assets/index_img/section5_list_item_mainbg.png);
  background-size: cover;
  background-repeat: no-repeat;
}
.section5_list_item_main::before{
  top: -10px;
  left: -10px;
}
.section5_list_item_main::after{
  bottom: -10px;
  right: -10px;
  transform: rotateX(180deg);
  transform: rotateZ(180deg);
}
.section5_list_item_tag{
  background-image: url(../assets/index_img/section5tagbg.png);
  display: inline-block;
  width: 155px;
  height: 40px;
  line-height: 40px;
  color: #1890FF;
  text-align: center;
  margin-bottom: 10px;
}


.section6{
  background-image: url(../assets/index_img/section6bg.png);
  background-position: top center;
  background-size: cover;
}
.section6 .section_title{
  color: #fff;
}
.section6_list{
  padding: 50px 0;
  text-align: center;
  background-color: #fff;
  border-radius: 20px;
}
.section6_list img{
  width: 120px;
  margin-bottom: 10px;
}
.section6_list .fs_24{
  margin-bottom: 20px;
}

.section7{
  background-image: url(../assets/index_img/section7bg.jpg);
  background-position: top center;
  background-size: cover;
}

.section7_list{
  color: #fff;
  padding: 50px !important;
  position: relative;
  height: 520px;
  border-radius: 10px;
  overflow: hidden;
  transition: all 0.45s ease;
}
.section7_list_bg{
  position: absolute;
  right: 0;
  bottom: 0;
  width: 90%;
}
.section7_list .fs_30{
  border-bottom: 2px #fff dashed;
  padding-bottom: 10px;
  margin-bottom: 10px;
}
.section7_list1{
  background-image: linear-gradient(0deg, rgba(239, 243, 252, 1) 0%, rgba(41, 162, 255, 1) 99%);
}
.section7_list2{
  background-image: linear-gradient(0deg, rgba(239, 243, 252, 1) 0%, rgba(56, 96, 244, 1) 100%);
}
.section7_list3{
  background-image: linear-gradient(0deg, rgba(239, 243, 252, 1) 0%, rgba(19, 42, 77, 1) 100%);
}
.section7_list1_title{
  margin-bottom: 50px;
  position: relative;
}
.section7_list_main{
  font-size: 18px;
  display: none;
  position: relative;
}
.section7_list_active{
  background-image: linear-gradient(to right, #eff3fc, #ced9ec);
  color: #333;
}
.section7_list_active .section7_list_bg{
  width: 350px;
  opacity: .5;
}
.section7_list_active .section7_list_main{
  display: block;
}
.section7_list_active .fs_30{
  border-bottom-color: #333;
}
.section7_list_main_tag{
  margin-bottom: 20px;
}
.section7_list_main_tag img{
  display: inline-block;
  width: 18px;
  margin-right: 15px;
}

.section8 img{
  width: 90%;
  border-radius: 50%;
}

.section8_reviews_msg{
  padding: 20px;
  height: 190px;
  margin-bottom: 20px;
  background-color: #fff;
  border-radius: 10px;
  position: relative;
  border: #F2F2F2 solid 1px;
  box-shadow: 5px 5px 8px #dedede;
  text-align: justify;
}
.section8_reviews_msg::before{
  content: '';
  position: absolute;
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 12px solid #F2F2F2;
  bottom: -11px;
  left: 20px;
}
.section8_reviews_msg::after{
  content: '';
  position: absolute;
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 12px solid #fff;
  bottom: -9px;
  left: 20px;
}
.section8_reviews_msg span{
  position: absolute;
  width: 30px;
  height: 23px;
  top: -10px;
  left: 20px;
  background-image: url(../assets/index_img/section8_reviews_msgbg.png);
  background-size: 100%;
  background-repeat: no-repeat;
}

.section9{
  background-image:  url(../assets/index_img/section9bg.jpg);
  padding-bottom: 0;
}






@media screen and (min-width: 1440px){
    .section5 .center{
      padding: 0 100px;
    }
    .section8 .center{
      padding: 0 170px;
    }
}
@media screen and (max-width: 768px) {
    .section5{
      padding-bottom: 40px;
    }
    .section5_list_title_text{
      font-size: 16px;
    }

}
</style>
